var map = {
	"./de.png": "aedd",
	"./en.png": "56fa",
	"./es.png": "9a7b",
	"./fr.png": "e02e",
	"./it.png": "44a4",
	"./iw.png": "f884",
	"./ru.png": "13ec",
	"./uk.png": "a2ae",
	"./zh-CN.png": "0cbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb08";